import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { ImplementDetails, InspectionDetails, ComponentDetails, ImplementHistory, LastInspectionDetailsForImplementModel } from './implement-rebuild';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { AddObservationPointModal, RebuildImplementVM, ImplementCycleDetails, ImplementRebuildCompleteVM, UpdateImplementTargets } from '../../add-observation-point/add-observation-point-modal';
import { EquipmentDetailsParams, Tuple } from '../../setup-equipment/setup-equipment.model';
import { ImplementForEquipmentDetails, InspectionHistoryDetails, ImplementHistoryVM } from '../../equipment-details/equipment-details.model';
import { FECRDashboardSearch, FECRDashboradImplementVM, FECRInspectionHistoryVM } from '../FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { GenericIdName } from '../../setup-implement/setup-implement.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ImplementRebuildService {

  constructor(private _http: HttpClient) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  //public returnGETById(id: string): Observable<ImplementDetails> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', id)
  //  };
  //  return this._http.get("Api/Implement/ReturnGETById", options).share().map(
  //    (response: Response) => <ImplementDetails>response.json()).catch(this.handleError);
  //}

  //public returnEquipmentForGET(id: string): Observable<EquipmentDetailsParams> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', id)
  //  };
  //  return this._http.get('Api/Implement/ReturnEquipmentForGET', options).share().map(
  //    (response: Response) => <EquipmentDetailsParams>response.json()).catch(this.handleError);
  //}

  //public GetEquipmentInspectionHistoryForImplement(get_auto: number): Observable<InspectionHistoryDetails[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/Implement/GetEquipmentInspectionHistoryForImplement', options).share().map(
  //    (response: Response) => <InspectionHistoryDetails[]>response.json()).catch(this.handleError);
  //}

  //public GetLastInspectionDetailsForImplement(get_auto: number): Observable<LastInspectionDetailsForImplementModel> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/Implement/GetLastInspectionDetailsForImplement', options).share().map(
  //    (response: Response) => <LastInspectionDetailsForImplementModel>response.json()).catch(this.handleError);
  //}

  //public GetSchematicsForImplement(get_auto: number): Observable<ImplementForEquipmentDetails[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/FECRImplement/GetSchematicsForFECRImplement', options).share().map(
  //    (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  //}

  //public GetFECRInspectionHistory(get_auto: number): Observable<FECRInspectionHistoryVM[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/FECRImplement/GetFECRInspectionHistoryInfo', options).share().map(
  //    (response: Response) => <FECRInspectionHistoryVM[]>response.json()).catch(this.handleError);
  //}

  //public returnInspectionDetailsForGET(id: string): Observable<InspectionDetails[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', id)
  //  };
  //  return this._http.get("Api/GETInspection/ReturnInspectionDetailsForGET", options).share().map(
  //    (response: Response) => <InspectionDetails[]>response.json()).catch(this.handleError);
  //}
  //public returnComponentsForGET(id: string): Observable<ComponentDetails[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', id)
  //  };
  //  return this._http.get("Api/GETComponent/ReturnComponentsForGET", options).share().map(
  //    (response: Response) => <ComponentDetails[]>response.json()).catch(this.handleError);
  //}
  //public returnHistoryForGET(id: string): Observable<ImplementHistory[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', id)
  //  };
  //  return this._http.get("Api/GETInspection/ReturnHistoryForGET", options).share().map(
  //    (response: Response) => <ImplementHistory[]>response.json()).catch(this.handleError);
  //}

  //public SaveObservationPoint(params: AddObservationPointModal) {
  //  return this._http.post('api/Implement/storeObservationPoint', params).share().map(
  //    (response: Response) => <string>response.json()).catch(this.handleError);
  //}

  //public RebuildImplement(data: RebuildImplementVM): Observable<boolean> {
  //  const options = {
  //    params: new HttpParams().set('ImplementId', data.ImplementId.toString())
  //      .set('Status', data.Status.toString())
  //      .set('WorkshopId', data.WorkshopId.toString())
  //      .set('cost', data.cost.toString())
  //      .set('RebuilStartDate', data.RebuilStartDate.toDateString())
  //      .set('comment', data.comment.toString())
  //      .set('jobsiteID', data.jobsiteID.toString())
  //  };
  //  return this._http.get("Api/Implement/PerformRebuildImplement", options).share().map(
  //    (response: Response) => <boolean>response.json()).catch(this.handleError);
  //}

  //public GetCurrentCycleDetails(ImplementId: number): Observable<ImplementCycleDetails> {
  //  const options = {
  //    params: new HttpParams().set('ImplementId', ImplementId.toString())
  //  };
  //  return this._http.get('api/Implement/GetCycleDetialsForImplement', options).share().map(
  //    (response: Response) => <ImplementCycleDetails>response.json()).catch(this.handleError);
  //}

  //// int ImplementId,  DateTime RebuildEndDate, string comment, int jobsiteID,
  //// //         int Hours, int Bcm, int Tons
  //public SaveRebuildComplete(data: ImplementRebuildCompleteVM): Observable<boolean> {
  //  const options = {
  //    params: new HttpParams().set('ImplementId', data.ImplementId.toString())
  //      .set('StartDate', data.StartDate.toDateString())
  //      .set('comment', data.comment.toString())
  //      .set('jobsiteID', data.jobsiteID.toString())
  //      .set('Hours', data.Hours.toString())
  //      .set('Bcm', data.BCM.toString())
  //      .set('Tons', data.Tons.toString())
  //      .set('CycleNo', data.CycleNo.toString())
  //  };
  //  return this._http.get("Api/Implement/PerformRebuildCompleteImplement", options).share().map(
  //    (response: Response) => <boolean>response.json()).catch(this.handleError);
  //}

  //public UpdateImplementTargets(data: UpdateImplementTargets): Observable<boolean> {
  //  const options = {
  //    params: new HttpParams().set('ImplementId', data.ImplementId.toString())
  //      .set('Hours', data.Hours.toString())
  //      .set('Bcm', data.BCM.toString())
  //      .set('Tons', data.Tons.toString())
  //      .set('CycleNo', data.CycleNo.toString())
  //      .set('NewHours', data.NewHours.toString())
  //      .set('NewBCM', data.NewBCM.toString())
  //      .set('NewTons', data.NewTons.toString())
  //      .set('CycleId', data.CycleId.toString())
  //  };
  //  return this._http.get("Api/Implement/PerformUpdateImplementTargets", options).share().map(
  //    (response: Response) => <boolean>response.json()).catch(this.handleError);
  //}


  //public GetImplementHistoryDetails(get_auto: number): Observable<ImplementHistoryVM[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/Implement/GetImplementHistroy', options).share().map(
  //    (response: Response) => <ImplementHistoryVM[]>response.json()).catch(this.handleError);
  //}

  //public GetImplementCycleDetails(get_auto: number): Observable<ImplementCycleDetails[]> {
  //  const options = {
  //    params: new HttpParams().set('get_auto', get_auto.toString())
  //  };
  //  return this._http.get('api/Implement/GetImplementCycleInfo', options).share().map(
  //    (response: Response) => <ImplementCycleDetails[]>response.json()).catch(this.handleError);
  //}

  //public getRepairerList(): Observable<GenericIdName[]> {
  //  return this._http.get('api/FECRImplement/GetRepairerList').share().map(
  //    (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  //}



  //public getWorkshopList(repairerId: number): Observable<GenericIdName[]> {
  //  const options = {
  //    params: new HttpParams().set('repairerId', repairerId.toString())
  //  };
  //  return this._http.get('api/FECRImplement/GetWorkShopListForRepairer', options).share().map(
  //    (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  //}

  //public MoveImplementToRepairer(reapirerId: number, workshopId: number, implementId: number): Observable<Tuple> {
  //  const options = {
  //    params: new HttpParams().set('reapirerId', reapirerId.toString())
  //      .set('workshopId', workshopId.toString())
  //      .set('implementId', implementId.toString())
  //  };
  //  return this._http.get('api/FECRImplement/MoveImplementtoRepairer', options).share().map(
  //    (response: Response) => <Tuple>response.json()).catch(this.handleError);
  //}

  //public ReturnImplementToFromRepairerInventory(implementId: number, jobsiteID: number): Observable<Tuple> {
  //  const options = {
  //    params: new HttpParams().set('implementId', implementId.toString())
  //      .set('jobsiteID', jobsiteID.toString())
  //  };
  //  return this._http.get('api/FECRImplement/ReturnRepairtToInventory', options).share().map(
  //    (response: Response) => <Tuple>response.json()).catch(this.handleError);
  //}

  public returnGETById(id: string): Observable<ImplementDetails> {
    const params = new HttpParams().set('get_auto', id);
    return this._http
      .get<ImplementDetails>('Api/Implement/ReturnGETById', { params })
      .pipe(catchError(this.handleError));
  }

  public returnEquipmentForGET(id: string): Observable<EquipmentDetailsParams> {
    const params = new HttpParams().set('get_auto', id);
    return this._http
      .get<EquipmentDetailsParams>('Api/Implement/ReturnEquipmentForGET', { params })
      .pipe(catchError(this.handleError));
  }

  public GetEquipmentInspectionHistoryForImplement(
    get_auto: number
  ): Observable<InspectionHistoryDetails[]> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<InspectionHistoryDetails[]>(
        'api/Implement/GetEquipmentInspectionHistoryForImplement',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public GetLastInspectionDetailsForImplement(
    get_auto: number
  ): Observable<LastInspectionDetailsForImplementModel> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<LastInspectionDetailsForImplementModel>(
        'api/Implement/GetLastInspectionDetailsForImplement',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public GetSchematicsForImplement(
    get_auto: number
  ): Observable<ImplementForEquipmentDetails[]> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<ImplementForEquipmentDetails[]>(
        'api/FECRImplement/GetSchematicsForFECRImplement',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public GetFECRInspectionHistory(
    get_auto: number
  ): Observable<FECRInspectionHistoryVM[]> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<FECRInspectionHistoryVM[]>(
        'api/FECRImplement/GetFECRInspectionHistoryInfo',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public returnInspectionDetailsForGET(
    id: string
  ): Observable<InspectionDetails[]> {
    const params = new HttpParams().set('get_auto', id);
    return this._http
      .get<InspectionDetails[]>(
        'Api/GETInspection/ReturnInspectionDetailsForGET',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public returnComponentsForGET(id: string): Observable<ComponentDetails[]> {
    const params = new HttpParams().set('get_auto', id);
    return this._http
      .get<ComponentDetails[]>(
        'Api/GETComponent/ReturnComponentsForGET',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public returnHistoryForGET(id: string): Observable<ImplementHistory[]> {
    const params = new HttpParams().set('get_auto', id);
    return this._http
      .get<ImplementHistory[]>(
        'Api/GETInspection/ReturnHistoryForGET',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public SaveObservationPoint(
    params: AddObservationPointModal
  ): Observable<string> {
    return this._http
      .post<string>('api/Implement/storeObservationPoint', params)
      .pipe(catchError(this.handleError));
  }

  public RebuildImplement(data: RebuildImplementVM): Observable<boolean> {
    const params = new HttpParams()
      .set('ImplementId', data.ImplementId.toString())
      .set('Status', data.Status.toString())
      .set('WorkshopId', data.WorkshopId.toString())
      .set('cost', data.cost.toString())
      .set('RebuilStartDate', data.RebuilStartDate.toDateString())
      .set('comment', data.comment)
      .set('jobsiteID', data.jobsiteID.toString());

    return this._http
      .get<boolean>('Api/Implement/PerformRebuildImplement', { params })
      .pipe(catchError(this.handleError));
  }

  public GetCurrentCycleDetails(
    ImplementId: number
  ): Observable<ImplementCycleDetails> {
    const params = new HttpParams().set('ImplementId', ImplementId.toString());
    return this._http
      .get<ImplementCycleDetails>(
        'api/Implement/GetCycleDetialsForImplement',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public SaveRebuildComplete(
    data: ImplementRebuildCompleteVM
  ): Observable<boolean> {
    const params = new HttpParams()
      .set('ImplementId', data.ImplementId.toString())
      .set('StartDate', data.StartDate.toDateString())
      .set('comment', data.comment)
      .set('jobsiteID', data.jobsiteID.toString())
      .set('Hours', data.Hours.toString())
      .set('Bcm', data.BCM.toString())
      .set('Tons', data.Tons.toString())
      .set('CycleNo', data.CycleNo.toString());

    return this._http
      .get<boolean>('Api/Implement/PerformRebuildCompleteImplement', { params })
      .pipe(catchError(this.handleError));
  }

  public UpdateImplementTargets(
    data: UpdateImplementTargets
  ): Observable<boolean> {
    const params = new HttpParams()
      .set('ImplementId', data.ImplementId.toString())
      .set('Hours', data.Hours.toString())
      .set('Bcm', data.BCM.toString())
      .set('Tons', data.Tons.toString())
      .set('CycleNo', data.CycleNo.toString())
      .set('NewHours', data.NewHours.toString())
      .set('NewBCM', data.NewBCM.toString())
      .set('NewTons', data.NewTons.toString())
      .set('CycleId', data.CycleId.toString());

    return this._http
      .get<boolean>('Api/Implement/PerformUpdateImplementTargets', { params })
      .pipe(catchError(this.handleError));
  }

  public GetImplementHistoryDetails(
    get_auto: number
  ): Observable<ImplementHistoryVM[]> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<ImplementHistoryVM[]>(
        'api/Implement/GetImplementHistroy',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public GetImplementCycleDetails(
    get_auto: number
  ): Observable<ImplementCycleDetails[]> {
    const params = new HttpParams().set('get_auto', get_auto.toString());
    return this._http
      .get<ImplementCycleDetails[]>(
        'api/Implement/GetImplementCycleInfo',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public getRepairerList(): Observable<GenericIdName[]> {
    return this._http
      .get<GenericIdName[]>('api/FECRImplement/GetRepairerList')
      .pipe(catchError(this.handleError));
  }

  public getWorkshopList(
    repairerId: number
  ): Observable<GenericIdName[]> {
    const params = new HttpParams().set('repairerId', repairerId.toString());
    return this._http
      .get<GenericIdName[]>(
        'api/FECRImplement/GetWorkShopListForRepairer',
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public MoveImplementToRepairer(
    reapirerId: number,
    workshopId: number,
    implementId: number
  ): Observable<Tuple> {
    const params = new HttpParams()
      .set('reapirerId', reapirerId.toString())
      .set('workshopId', workshopId.toString())
      .set('implementId', implementId.toString());

    return this._http
      .get<Tuple>('api/FECRImplement/MoveImplementtoRepairer', { params })
      .pipe(catchError(this.handleError));
  }

  public ReturnImplementToFromRepairerInventory(implementId: number,jobsiteID: number): Observable<Tuple> {
    const params = new HttpParams()
      .set('implementId', implementId.toString())
      .set('jobsiteID', jobsiteID.toString());

    return this._http.get<Tuple>('api/FECRImplement/ReturnRepairtToInventory', { params }).pipe(catchError(this.handleError));
  }



  public GetFECRForDashboardSearch(searchOptions: FECRDashboardSearch): Observable<FECRDashboradImplementVM[]> {
    return this._http.post<FECRDashboradImplementVM[]>('Api/FECRImplement/GetFECRImplementsForSearchSelection', searchOptions).pipe(catchError(this.handleError));
  }

  //public GetFECRForDashboardSearch(searchOptions: FECRDashboardSearch): Observable<FECRDashboradImplementVM[]> {
  //    return this._http.post('Api/FECRImplement/GetFECRImplementsForSearchSelection', searchOptions).share().map(
  //        (response: Response) => <FECRDashboradImplementVM[]>response.json()).catch(this.handleError);
  //}


}
